export const getNumberStrFromNumberCommas = (
  numStr: string | undefined,
  fixed?: number
) => {
  if (!numStr) return ''
  return Number((numStr?.toString() as any)?.replaceAll(',', ''))?.toFixed(
    fixed
  )
}

export const getNumberFromNumberCommas = (
  numStr: string | undefined,
  fixed?: number
): number | undefined => {
  if (numStr === undefined) return undefined
  if (fixed === undefined) return Number(numStr.toString()?.replaceAll(',', ''))
  return Number(
    Number((numStr?.toString() as any)?.replaceAll(',', '')).toFixed(fixed)
  )
}

export const getNumberCommasFixed = (numStr: any, fixed?: number) => {
  if (!numStr) return ''
  if (fixed !== undefined) {
    numStr = getNumberStrFromNumberCommas(numStr, fixed)
  }
  const numList: any = String(numStr)?.split('.')
  const numCommas = numberWithCommas(Number(numList[0]?.replaceAll(',', '')))
  let addNum = numCommas
  if (numList.length === 2) {
    addNum = addNum + '.' + numList[1]
  }
  return addNum
}

export const getPriceFromPoint = (price?: string | number) => {
  if (price === undefined) return undefined
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const priceNum = getNumberFromNumberCommas(price?.toString())! * 1000
  return getNumberCommasFixed(priceNum, 0)
}

export const getPointFromVnd = (point?: string | number) => {
  if (point === undefined) return undefined
  const pointNum = getNumberFromNumberCommas(point?.toString())! / 1000
  return pointNum
}

export function numberWithCommas(value: any) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const removeVietnameseTones = (str: string) => {
  if (str === '') return str
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
  str = str.replace(/đ/g, 'd')
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A')
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E')
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I')
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O')
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U')
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y')
  str = str.replace(/Đ/g, 'D')
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '')
  str = str.replace(/\u02C6|\u0306|\u031B/g, '')
  str = str.trim()
  return str
}

const useFormatData = () => {
  return {
    getNumberStrFromNumberCommas,
    getNumberCommasFixed,
    getNumberFromNumberCommas,
    removeVietnameseTones,
    getPriceFromPoint
  }
}

export default useFormatData
